
import { iif, Observable, of } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TServiceResult } from '@shared/helper/t-service-result';
import { LocalRepository } from '@shared/helper/local-repository';
import { PageList } from '@shared/model/categoryAndSearch/pageList-model';
import { CustomerModel, profileType } from '@shared/model/customerModels/customer-model';
import { SocialNetworkModel } from '@shared/model/customerModels/social-network-model';
import { HttpBaseService } from '../base_services/http_base.service';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { ContactModel } from '@shared/model/contact.model';
import { catchError, map, tap } from 'rxjs/operators';
import { TRANSFORM_PROFILE_DATA } from 'constants/storage-keys';

@Injectable({
  providedIn: 'root'
})



export class CustomerAggrigatorService extends HttpBaseService {

  constructor() {
    const repo = inject(LocalRepository);
    const http = inject(HttpClient);

    super(repo, http, 'v1/CuAggr');
  }

  GetGuestSocialNetworks(userId: string): Observable<TServiceResult<PageList<SocialNetworkModel>>> {
    return this.http.get<TServiceResult<PageList<SocialNetworkModel>>>(`${this.apiUrl}/GetGuestSocialNetworks/${userId}`);
  }

  getGuestCustomer(term: string): Observable<TServiceResult<CustomerModel>> {
    return this.http.get<TServiceResult<CustomerModel>>(`${this.apiUrl}/GetGuestCustomer/${term}`)
      .pipe(
        catchError(() => {
          return of(new TServiceResult<CustomerModel>(new CustomerModel(), '', null, true, ''));
        })
      )
  }

  getCustomer(term: string): Observable<TServiceResult<CustomerModel>> {
    return this.http.get<TServiceResult<CustomerModel>>(`${this.apiUrl}/GetCustomer/${term}`);
  }

  checkDuplicateUsername(username: string): Observable<TServiceResult<boolean>> {
    return this.http.get<TServiceResult<boolean>>(`${this.apiUrl}/CheckDuplicateUsername/${username}`)
  }

  getMyContacts(termFilter: TermFilterModel): Observable<TServiceResult<PageList<ContactModel>>> {
    return this.http.post<TServiceResult<PageList<ContactModel>>>(`${this.apiUrl}/GetMyContacts/`, termFilter);
  }

  getMyContactsinFeeds(termFilter: TermFilterModel): Observable<boolean> {
    return this.http.post<TServiceResult<PageList<ContactModel>>>(`${this.apiUrl}/GetMyContacts/`, termFilter)
      .pipe(
        map(x => x.hasError)
      );
  }



  transFormProfileId(term: string, forSession = false): Observable<TServiceResult<profileType>> {

    if (forSession) {
      const transformRawData = this.Repository.getLocalItem(TRANSFORM_PROFILE_DATA);
      const transformCachedData = transformRawData ? JSON.parse(transformRawData) : null;
      return iif(() => !!transformCachedData, of(transformCachedData),
        this.http.get<TServiceResult<profileType>>(`${this.apiUrl}/TransFormProfileId/${term}`).pipe(
          tap(res => {
            this.Repository.setLocalItem(TRANSFORM_PROFILE_DATA, JSON.stringify(res));
          })
        )
      );
    }
    else
      return this.http.get<TServiceResult<profileType>>(`${this.apiUrl}/TransFormProfileId/${term}`);

  }
}
